/**
 * Consumer UI class fragments — align with src/styles/tokens.css and globals.css sio-* utilities.
 * Prefer these or Tailwind `primary-*` over hardcoded hex or Tailwind `green-*` / `emerald-*`.
 */

/** Text link accent */
export const SIO_LINK = "sio-link";

/** Hub tabs (My Items, My Purchases, etc.) */
export const SIO_TAB_ACTIVE = "sio-tab-active";
export const SIO_TAB_INACTIVE = "sio-tab-inactive";

/** Listing price emphasis */
export const SIO_PRICE = "sio-price";

/** Map pin, shield, and similar accents */
export const SIO_ICON_ACCENT = "sio-icon-accent";

/** Status / quantity soft badge */
export const SIO_BADGE_POSITIVE = "sio-badge-positive";

/** Inline success / trust callout */
export const SIO_BANNER_POSITIVE = "sio-banner-positive";

/** Loading indicator — pair with sio-spinner-md | lg | xl */
export const SIO_SPINNER = "sio-spinner";

export const SIO_FOCUS_RING =
  "focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2";

export const SIO_INPUT_FOCUS =
  "focus:outline-none focus:ring-2 focus:ring-[var(--input-focus-ring)] focus:border-transparent";
